import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['sheet-preview-card', {
      compact: _vm.compact
    }]
  }, [_c('div', {
    staticClass: "sheet-preview-heading"
  }, [_vm._m(0), _c('span', {
    staticClass: "sheet-count"
  }, [_vm._v(_vm._s(_vm.total) + " por página")])]), _c('div', {
    staticClass: "sheet-stage"
  }, [_c('div', {
    staticClass: "sheet-page",
    style: _vm.pageStyle
  }, [_c('div', {
    staticClass: "sheet-printable-area",
    style: _vm.printableAreaStyle,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._l(_vm.positions, function (position) {
    return _c('div', {
      key: position.index,
      staticClass: "sheet-label",
      style: position.style
    }, _vm._l(_vm.miniatureElements, function (item) {
      return _c('span', {
        key: "".concat(position.index, "-").concat(item.id),
        class: "mini-".concat(item.tipo),
        style: _vm.miniatureStyle(item)
      });
    }), 0);
  })], 2)]), _c('div', {
    staticClass: "sheet-measures"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.pageWidth) + " × " + _vm._s(_vm.pageHeight))]), _vm._v(" mm página")]), _c('i'), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.labelWidth) + " × " + _vm._s(_vm.labelHeight))]), _vm._v(" mm etiqueta")])]), _vm.warnings.length ? _c('div', {
    staticClass: "sheet-warning"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle"
  }), _c('div', [_c('strong', [_vm._v("Confira antes de imprimir")]), _vm._l(_vm.warnings, function (warning) {
    return _c('span', {
      key: warning
    }, [_vm._v(_vm._s(warning))]);
  })], 2)]) : _c('div', {
    staticClass: "sheet-ok"
  }, [_c('i', {
    staticClass: "fas fa-check-circle"
  }), _c('span', [_vm._v("Medidas compatíveis e elementos dentro da área.")])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', {
    staticClass: "etq-panel-kicker"
  }, [_vm._v("Conferência")]), _c('h6', [_vm._v("Folha ou rolo completo")])]);
}];
export { render, staticRenderFns };